const s = {
  name: "PosPlatform",
  dimensions: { width: 40, height: 38 },
  content: `
<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 viewBox="0 0 40 38" style="enable-background:new 0 0 40 38;" xml:space="preserve">
<style type="text/css">
	.st0{fill: currentColor;}
</style>
<g>
	<g>
		<path class="st0" d="M0,2h34V0H0V2z"/>
		<path class="st0" d="M38,2h2V0h-2V2z"/>
		<path class="st0" d="M10,8H0V6h10V8z"/>
		<path class="st0" d="M14,8h2V6h-2V8z"/>
		<path class="st0" d="M40,8H20V6h20V8z"/>
		<path class="st0" d="M0,12v2h40v-2H0z"/>
		<path class="st0" d="M2,20H0v-2h2V20z"/>
		<path class="st0" d="M24,20h2v-2h-2V20z"/>
		<path class="st0" d="M26,32h-2v-2h2V32z"/>
		<path class="st0" d="M0,38h2v-2H0V38z"/>
		<path class="st0" d="M6,38v-2h20v2H6z"/>
		<path class="st0" d="M30,36v2h10v-2H30z"/>
		<path class="st0" d="M0,30h20v2H0V30z"/>
		<path class="st0" d="M26,24H0v2h26V24z"/>
		<path class="st0" d="M6,18h14v2H6V18z"/>
		<path class="st0" d="M32,18c-1.1,0-2,0.9-2,2v10c0,1.1,0.9,2,2,2h6c1.1,0,2-0.9,2-2V20c0-1.1-0.9-2-2-2H32z M32,20h6v4h-6V20z
			 M38,30h-6v-4h6V30z"/>
	</g>
</g>
</svg>
  `
};
export {
  s as PosPlatform
};
